import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { get, isNil } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import EmptySelectedInboxes from 'containers/AttributionManager/EmptySelectedInboxes';
import ManagerInboxes from 'containers/AttributionManager/ManagerInboxes';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import {
  StyledContainer,
  StyledGridItem,
} from 'containers/AttributionManager/styles';
import {
  makeSelectUserInboxes,
  makeSelectManagers,
  makeSelectCountInboxes,
} from 'containers/AttributionManager/selector';
import { INBOXES_TYPES } from 'containers/AttributionManager/constants';
import { makeSelectNotificationsInboxes } from 'containers/AppContainer/selectors';
import {
  requestGetUsersInboxes,
  requestGetManagersBawaba,
  requestUpdateAssignementInboxes,
  requestGetCountInboxes,
} from 'containers/AttributionManager/action';
import { extractUser } from 'containers/AttributionManager/utils';
import ManagerContainer from 'containers/AttributionManager/ManagerCard/ManagerContainer';
import AreasList from 'containers/AttributionManager/Area';
export interface AttributionManagerProps {
  intl: IntlShape;
  listings: any;
  usersInboxes: any;
  managers: any;
  requestGetUsersInboxes: Function;
  requestGetManagersBawaba: Function;
  requestUpdateAssignementInboxes: Function;
  managerNotifications: any;
  requestGetCountInboxes: Function;
  countInboxes: any;
}

export const AttributionTransactionManagerPage: React.FC<AttributionManagerProps> = (
  props,
): JSX.Element => {
  const [selectedInboxe, setSelectedInboxe] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);

  useEffect(() => {
    props.requestGetUsersInboxes();
    props.requestGetManagersBawaba();
    props.requestGetCountInboxes();
  }, []);
  return (
    <Grid
      container
      direction="row"
      style={{ ...StyledContainer, position: 'absolute' }}
      spacing={2}
    >
      <Grid item>
        <ManagerInboxes
          listings={props.listings}
          setSelectedInboxe={setSelectedInboxe}
          selectedInboxe={selectedInboxe}
          managers={props.managers}
          managerNotifications={props.managerNotifications}
          usersInboxes={props.usersInboxes}
          countInboxes={props.countInboxes}
          inboxes={get(props.listings, 'managerInboxes', []).filter(
            (el: any) => el.type === INBOXES_TYPES.TRANSACTION,
          )}
        />
      </Grid>

      {isNil(selectedInboxe) ? (
        <Grid item xs style={StyledGridItem}>
          <EmptySelectedInboxes />
        </Grid>
      ) : (
        !isNil(selectedInboxe) && (
          <AreasList
            listings={props.listings}
            setSelectedArea={setSelectedArea}
            selectedArea={selectedArea}
            managerNotifications={props.managerNotifications}
            managers={props.managers}
            usersInboxes={props.usersInboxes}
            countInboxes={props.countInboxes}
            inboxes={get(props.listings, 'managerInboxes', []).filter(
              /* istanbul ignore next */ (el: any) =>
                el.type === INBOXES_TYPES.TRANSACTION,
            )}
          />
        )
      )}
      <Grid item xs style={StyledGridItem}>
        {isNil(selectedArea) && !isNil(selectedInboxe) ? (
          <EmptySelectedInboxes />
        ) : (
          !isNil(selectedArea) &&
          !isNil(selectedInboxe) && (
            <ManagerContainer
              usersInboxe={extractUser(
                props.usersInboxes,
                selectedInboxe,
                selectedArea,
                props.listings,
              )}
              usersInboxes={props.usersInboxes}
              managers={props.managers}
              requestUpdateAssignementInboxes={
                props.requestUpdateAssignementInboxes
              }
              requestGetUsersInboxes={props.requestGetUsersInboxes}
              selectedInboxe={selectedInboxe}
              countInboxes={props.countInboxes}
              listings={props.listings}
              isTransactionAttribution={true}
              selectedArea={selectedArea}
            />
          )
        )}
      </Grid>
    </Grid>
  );
};

const mapDispatchToProps = {
  requestGetUsersInboxes,
  requestGetManagersBawaba,
  requestUpdateAssignementInboxes,
  requestGetCountInboxes,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  usersInboxes: makeSelectUserInboxes(),
  managers: makeSelectManagers(),
  managerNotifications: makeSelectNotificationsInboxes(),
  countInboxes: makeSelectCountInboxes(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AttributionTransactionManagerPage));
